import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Vision from "@/components/site/Vision";
import Configurations from "@/components/site/Configurations";
import Location from "@/components/site/Location";
import RegisterContact from "@/components/site/RegisterContact";
import Footer from "@/components/site/Footer";
import { useEffect } from "react";
import { useContent } from "@/content/ContentContext";

export default function HomePage() {
  const { content, loading } = useContent();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("in");
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [content]);

  if (loading || !content) {
    return (
      <div className="min-h-screen bg-[var(--bone)] flex items-center justify-center">
        <p className="text-[var(--ink-soft)] text-sm tracking-[0.3em] uppercase">Loading…</p>
      </div>
    );
  }

  const packageUrl = content.leasing_package?.url || "";
  const registerContent = {
    ...(content.register || {}),
    phone: content.location?.phone || content.footer?.phone,
    email: content.location?.email || content.footer?.email,
    address_line_1: content.location?.address_line_1,
    address_line_2: content.location?.address_line_2,
  };

  return (
    <main data-testid="home-page" className="bg-[var(--bone)] text-[var(--ink)]">
      <Navbar />
      <Hero content={content.hero} />
      <Vision content={content.vision} />
      <Configurations content={content.configurations} />
      <Location content={content.location} />
      <RegisterContact content={registerContent} packageUrl={packageUrl} />
      <Footer content={content.footer} />
    </main>
  );
}
